import React, { FC } from 'react';
import { ReactComponent as CurrencyIcon } from 'assets/icons/coin.svg';
import { ReactComponent as LocationIcon } from 'assets/icons/location.svg';
import TripStatus from '../trip-status';
import { TripHistoryType } from 'models/trip-history.model';
import { formatNumber, getTripStatus } from 'utils/functions';
type TripHistoryCardDetailsProps = {
  tripDetails: TripHistoryType;
};
const TripHistoryCardDetails: FC<TripHistoryCardDetailsProps> = ({ tripDetails }) => {
  return (
    <div className='px-4 py-3 space-y-4 grow'>
      <div className='flex justify-between items-center text-sm gap-10'>
        <div className='flex items-center gap-2 flex-wrap'>
          <h4 className='font-medium  text-base text-gray-6'>
            #{tripDetails?.order_code?.toUpperCase() ?? ''}
          </h4>
        </div>

        <TripStatus type={getTripStatus(tripDetails)} />
      </div>
      <div className='flex flex-col justify-between gap-4 items-start text-sm'>
        <p className='flex items-center gap-2 text-gray-6 shrink-0'>
          <CurrencyIcon />
          {formatNumber(tripDetails.amount)}
        </p>
        <p className='flex gap-2'>
          <LocationIcon className='mt-[4px] min-w-[16px]' />
          <span className='max-sm:break-words'>{tripDetails.address}</span>
        </p>
      </div>
    </div>
  );
};

export default TripHistoryCardDetails;
